import React from "react";

export default function UnderConstruction() {
    return (
        <div
            className="bg-dark d-flex flex-column p-2"
            style={{ height: "100vh" }}
        >
            <div className="text-white fs-6 fw-light text-uppercase">
                faculty of architecture and environmental design, maejo university
            </div>
            <div className="my-auto text-center">
                <div
                    className="text-light display-4 fw-bold"
                    style={{ letterSpacing: "5px" }}
                >
                    COMING SOON
                </div>
                <div
                    className="border-top border-4 border-white mx-auto mt-3 pt-4 text-uppercase"
                    style={{ width: "20%" }}
                >under construction<br />ERROR: SERV.35</div>
            </div>
            <div className="text-light text-uppercase">คณะสถาปัตยกรรมศาสตร์และการออกแบบสิ่งแวดล้อม มหาวิทยาลัยแม่โจ้</div>
        </div>
    );
}
